// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Component Files
import { FullPageDialogContainerComponent } from './full-page-dialog-container.component';

@NgModule({
    declarations: [FullPageDialogContainerComponent],
    exports: [FullPageDialogContainerComponent],
    imports: [CommonModule]
})
export class FullPageDialogContainerModule {}
